<template>
  <div
    class="mx-auto"
    style="max-width: 600px"
  >
    <v-row
      v-if="!isListStyle"
      dense
    >
      <!-- <v-col>
        <v-btn @click="test">
          AAA
        </v-btn>
      </v-col> -->
      <template v-for="app in apps">
        <v-col
          v-if="$config.isUAT || !app.testingOnly"
          :key="app.desc"
          cols="3"
          sm="2"
        >
          <v-card
            flat
            tile
            ripple
            color="transparent"
            class="pa-2"
            :to="app.to"
            :href="app.href"
            :target="app.target"
          >
            <v-img
              :src="app.imgSrc"
            />
            <div :class="['text-center', $i18n.locale === 'pt' ? 'ptFontSize' : 'text-caption']">
              {{ app.desc }}
            </div>
          </v-card>
        </v-col>
      </template>
    </v-row>

    <v-list
      v-else
      dense
    >
      <template v-for="app in apps">
        <v-list-item
          v-if="$config.isUAT || !app.testingOnly"
          :key="app.desc"
          :to="app.to"
          :href="app.href"
          :target="app.target"
          link
        >
          <v-list-item-avatar rounded="0">
            <v-img
              :src="app.imgSrc"
            />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title :class="[$i18n.locale === 'pt' ? 'ptFontSize' : 'text-caption']">
              {{ app.desc }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </div>
</template>

<style scoped>
  .ptFontSize {
    font-size: 10px;
  }
</style>

<script>
import '@/lib/vender/govapp.js'
import { parseJwt } from '@/utils/utils'
import { getStorage } from '@/utils/storageUtil'

export default {
  props: {
    isListStyle: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      appMode: process.env.VUE_APP_MODE
    }
  },
  computed: {
    contactsAppUrl: function () {
      let lang = 'zh-hant'
      if (this.$i18n.locale === 'pt') {
        lang = 'pt'
      }
      let url = `/${lang}/g2e-contacts-app/main?action=govmo_entity_account_login&mode=${process.env.VUE_APP_MODE}`
      // In new G2E app, below code will not run. It will use \views\Redirect\Contacts.vue
      if (process.env.VUE_APP_MODE === 'APP' && getStorage('g2e-jwt-token')) {
        url = url + '&token=' + btoa(parseJwt(getStorage('g2e-jwt-token')).access_token)
      }
      // let url = 'https://g2e.gov.mo/zh-hant/g2e-contacts-app/main?pwa=1'
      return url
    },
    apps: function () {
      return [
        {
          imgSrc: require('@/assets/icon/tasklist.png'),
          to: '/tasklist',
          desc: this.$t('Main.Work')
        },
        {
          imgSrc: require('@/assets/icon/eleave.png'),
          to: '/eleave',
          desc: this.$t('Main.Absence')
        },
        {
          imgSrc: require('@/assets/icon/training.png'),
          to: '/training',
          desc: this.$t('Main.Training')
        },
        {
          imgSrc: require('@/assets/icon/attendance.png'),
          to: '/redirect/attendance?type=attendanceSelf',
          desc: this.$t('Main.Attendance')
        },
        {
          imgSrc: require('@/assets/icon/attendance.png'),
          href: '/ext/attendance/mobile/home?mode=' + this.appMode,
          desc: this.$t('Main.Attendance') + ' new',
          testingOnly: true
        },
        {
          imgSrc: require('@/assets/icon/hr.png'),
          to: '/humanResources',
          desc: this.$t('Main.HR')
        },
        // {
        //   imgSrc: require('@/assets/icon/contacts.png'),
        //   desc: this.$t('Main.Contact'),
        //   to: '/redirect/contacts?url=' + this.contactsAppUrl
        // },
        {
          imgSrc: require('@/assets/icon/contacts.png'),
          desc: this.$t('Main.Contact'),
          href: this.contactsAppUrl
        },
        {
          imgSrc: require('@/assets/icon/opinion.png'),
          to: '/box/GeneralOpinion',
          desc: this.$t('Main.Opinion')
        },
        {
          imgSrc: require('@/assets/icon/outbox.png'),
          to: '/outbox/Create',
          desc: this.$t('TaskList.Outbox')
        },
        {
          imgSrc: require('@/assets/icon/ssm.png'),
          href: 'https://app.ssm.gov.mo/healthPHD/page/index.html',
          desc: this.$t('Text.HealthPHD'),
          target: '_blank'
        }
        // {
        //   imgSrc: require('@/assets/icon/payslip-g2e-app-icon.png'),
        //   href: 'https://eserv5.dsf.gov.mo/g2eegp101/public/dsf/index.html',
        //   desc: this.$t('App.PaySlip')
        // },
        // {
        //   imgSrc: require('@/assets/icon/payslip-g2e-app-icon.png'),
        //   href: 'https://eserv5.dsf.gov.mo/g2eegp101/public/dsf/index.html',
        //   desc: this.$t('App.PaySlip') + 1,
        //   target: '_blank'
        // }
        // {
        //   imgSrc: require('@/assets/icon/opinion.png'),
        //   to: '/tools/index',
        //   desc: this.$t('Tools.Title')
        // }
      ]
    }
  },
  methods: {
    test: function () {
      // eslint-disable-next-line no-undef
      govapp.openQRCode()
      // govapp.openURL({
      //   url: 'https://eserv5.dsf.gov.mo/g2eegp101/public/dsf/index.html',
      //   openMode: 'browser'
      // })
    }
  }
}
</script>
